import React, { useState, useEffect } from "react";
import { handleForgotPassword, notifyUser } from "../../../api/auth";
import Link from "next/link";
// import Image from 'next/image';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import "./style.scss";

function Footer(props) {
  const [showTopFooter, setShowTopFooter] = useState(true);
  const [Form, setForm] = useState({
    email: "",
    emailValid: "",
    loading: false,
  });

  useEffect(() => {
    if (Object.keys(Form.email).length > 0) {
      validate("email");
    }
  }, [Form.email]);

  const updateField = (field, val) => {
    setForm({ ...Form, [field]: val });
  };

  const validate = (field) => {
    let regex, valid;
    let value = Form[field];
    switch (field) {
      case "email":
        regex =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        setForm({ ...Form, [field + "Valid"]: regex.test(value) });
        break;
    }
  };

  const validateForm = () => {
    const { emailValid } = Form;
    return !!emailValid;
  };

  const NotifyEmail = () => {
    if (validateForm()) {
      setForm({ ...Form, loading: true });

      let data = {
        email: Form.email,
      };

      notifyUser(data).then((res) => {
        setForm({ ...Form, loading: false, email: "" });
      });
    }
  };

  useEffect(() => {
    if (window.location.href.indexOf("community") > -1) {
      setShowTopFooter(false);
    } else {
      setShowTopFooter(true);
    }
  }, []);
  return (
    <>
      <div className="footer">
        {/* <div className="top-footer">
				<div className="container">
					<h1 className="text-center headingF headingF-sm">Become part of the BAYAN community</h1>
						<ul>
							<li className="alumni">
								<span>Alumni + Students</span>
								<Link href="/register" as="/register">
									<a className="bayan-button learn-more-btn">Connect with our members</a>
								</Link>
							</li>
							<li className="chat">
								<span>Chat with a chaplain online</span>
								<Link href="/register" as="/register">
									<a className="bayan-button learn-more-btn">Have a question?</a>
								</Link>
							</li>
							<li className="trending">
								<span>Trending News And Question</span>
								<Link href="/register" as="/register">
									<a className="bayan-button learn-more-btn">Join the discussion!</a>
								</Link>
							</li>
						</ul>
				</div>
			</div> */}
        {/* {showTopFooter &&
				<div className="top-footer top-footer-new">
					<div className="container">
						<h1 className="text-center headingF headingF-sm">Become part of the BAYAN community</h1>
						<div className="field">
							<input id="_email" name="email" type="email" className={"is-input email-field " + (Form.emailValid === false ? 'input-err' : Form.emailValid === true ? 'input-valid' : '')}
								placeholder="Email" value={Form.email} onChange={(e) => updateField('email', e.target.value)} />
							{Form.emailValid === false && <small className='err-msg'>*Must enter a valid Email.</small>}
							<div className={"login-btn " + ((!validateForm() || Form.loading) ? 'disabled' : '')} onClick={() => NotifyEmail()}>
								Send Link {Form.loading && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />}
							</div>
						</div>
					</div>
				</div>
			} */}

        <div className="bottom-footer">
          <div className="second-last">
            <div className="left">
              <p>
                <a>
                  {/* <Image
									src="/icons/bayan-only.svg"
									alt="bayan-logo"
									width={160}
									height={70}
									loading="lazy"
									className="mob-img"
								/> */}
                  <img
                    src="/icons/bayan-only.svg"
                    alt="bayan-logo"
                    width="160"
                  />
                </a>
              </p>

              {/* <div className="logo-area">
									<span><img src="/icons/logo-in.png"></img> BAYAN</span>
							</div> */}
              <span className="footerTitle">
                ACCREDITED GRADUATE ISLAMIC STUDIES
              </span>
            </div>
            <div className="bottom-edu">
              <div className="contact-section">
                {/* <Image
									src={`${process.env.IMAGES_BASE_URL}/static-content/phone.png.webp`}
									alt="phone"
									width={20}
									height={20}
									loading="lazy"
									className="mob-img"
								/> */}
                <a className="fit-content" href="tel:714 862-2926">
                  <img
                    src={`${process.env.IMAGES_BASE_URL}/static-content/phone.png.webp`}
                    alt="phone"
                    width="25"
                  />
                  <span>(714) 862-2926</span>
                </a>
              </div>
              <div className="contact-section">
                {/* <Image
									src={`${process.env.IMAGES_BASE_URL}/static-content/email.png.webp`}
									alt="mail"
									width={20}
									height={20}
									loading="lazy"
									className="mob-img"
								/> */}
                <a
                  className="fit-content"
                  href="mailto:support@bayanonline.org"
                >
                  <img
                    src={`${process.env.IMAGES_BASE_URL}/static-content/email.png.webp`}
                    alt="mail"
                    width="25"
                  />
                  <span>support@bayanonline.org</span>
                </a>
              </div>
              <div className="contact-section">
                {/* <Image
									src={`${process.env.IMAGES_BASE_URL}/static-content/map.png.webp`}
									alt="location"
									width={20}
									height={20}
									loading="lazy"
									className="mob-img"
								/> */}
                <img
                  src={`${process.env.IMAGES_BASE_URL}/static-content/map.png.webp`}
                  alt="location"
                  width="25"
                />
                <span>1407 E 60th St, Chicago, IL 60637</span>
              </div>
              <div className="contact-section">
                {/* <Image
									src={`/icons/noun_mailbox@3x.png`}
									alt="location"
									width={20}
									height={20}
									loading="lazy"
									className="mob-img"
								/> */}
                <img
                  src={`/icons/noun_mailbox@3x.png`}
                  alt="location"
                  width="20"
                />
                <span>2854 N. Santiago Blvd., Suite 201, Orange, CA 92867</span>
              </div>
              <div className="contact-section">
                {/* <Image
									src={`/icons/noun_mailbox@3x.png`}
									alt="location"
									width={20}
									height={20}
									loading="lazy"
									className="mob-img"
								/> */}
                <img src={`/icons/bill.png`} alt="Tax" width="20" />
                <span>Tax ID #: 46-2431099.</span>
              </div>
            </div>
          </div>
          <div>
            <p>
              © {new Date().getFullYear()} Bayan | All Rights Reserved |{" "}
              <Link href="/" as="/">
                <a>Home</a>
              </Link>{" "}
              |{" "}
              <Link href="/contact" as="/contact">
                <a>Contact</a>
              </Link>{" "}
              |{" "}
              <Link href="/privacy-policy" as="/privacy-policy">
                <a>Privacy Policy</a>
              </Link>{" "}
              |{" "}
              <Link href="/terms-of-service" as="/terms-of-service">
                <a>Terms of Use</a>
              </Link>{" "}
              |{" "}
              <a target="_blank" href="https://mycts.ctschicago.edu/">
                Student Portal
              </a>{" "}
              |{" "}
              <Link href="/sitemap" as="/sitemap">
                <a>Sitemap</a>
              </Link>
            </p>
          </div>
          <div>
            <p>
              <a href="https://plexuss.com" target="_blank">
                {/* <Image
									src={`${process.env.IMAGES_BASE_URL}/static-content/plexuss_powered.svg.webp`}
									alt="plexuss-logo"
									width={55}
									height={55}
									loading="lazy"
									className="mob-img"
								/> */}
                <img
                  src={`${process.env.IMAGES_BASE_URL}/static-content/plexuss_powered.svg.webp`}
                  alt="bayan-logo"
                  width="55"
                />
              </a>
              <span>
                Powered
                <br />
                by Plexuss
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
